module.exports = __webpack_public_path__ + "static/media/smarthome.f204fcac.jpg";